import React, { useContext, useState } from 'react';
import { Timeout } from '../../functions/functions';
import { ShowDoctorContext } from './types';
import ButtonsForm from '../../HtmlComponents/ButtonsForm';
import { useDispatch } from 'react-redux';
import { DeleteDoctorApi } from '../../redux/doctors/doctorApiCalls';
import ShowErrorMsg from '../../HtmlComponents/ShowErrorMsg';

interface props {
  modal: boolean,
  toggle: any
}

const DeleteDoctorModal:React.FC<props> = ({ modal, toggle }) => {
  const { setShowSuccessMsg, selectedDoctor } = useContext(ShowDoctorContext)

  const [loading, setLoading] = useState(false)
  const dispatch: any = useDispatch()

  const [errors, setErrors] = useState<string[]>([])

  const handleSubmit = async (e: any) => {
    e.preventDefault()
    try {
      setLoading(true)
      const response: any = await dispatch(DeleteDoctorApi(selectedDoctor._id))
      if(response === true) {
        toggle()
        setShowSuccessMsg(true)
        setTimeout(() => setShowSuccessMsg(false), Timeout) 
        setErrors([])
      } else {
        setErrors(response)
      }
    } finally {
      setLoading(false)
    }
  }


  return (
    <>
      {modal && (
        <>
          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div
              className="fixed inset-0 w-full h-full bg-black opacity-40"
              onClick={toggle}
            ></div>
            <div className="flex items-center min-h-screen px-4 py-8">
              <div className="relative w-full p-4 max-w-lg mx-auto bg-white rounded-md shadow-lg">
                <div className="mt-3">
                  {/* Start Modal Body */}
                  <form
                    className="mt-2 sm:ml-4 sm:text-left"
                    onSubmit={handleSubmit}
                  >
                    <ShowErrorMsg errors={errors} setErrors={setErrors} />
                    <ButtonsForm loading={loading} typeBtn='Supprimer' toggle={toggle}/>
                  </form>
                  {/* End Modal Body */}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default DeleteDoctorModal

